import { jsx as _jsx } from "react/jsx-runtime";
import { ViewDetail } from '../../components/view_detail/view_detail.component';
const DataViewDetailPage = () => {
    return _jsx(ViewDetail, {});
};
export default DataViewDetailPage;
